import React from "react";
import { Link } from "react-router-dom";
/*eslint-disable */

declare const window: any;
const GoHyundaiComponent: React.FC = () => {
  return (
    <div className="go-hyundai">
      {/* H2 - Título de la sección */}
      <h2 className="title">Explora todo lo que Hyundai tiene preparado para tí</h2>
      
      <Link to={"/"} className="btn-go-hyundai">Regresar a Hyundai</Link>
    </div>
  );
};

export default GoHyundaiComponent;